import ViewResolver from '@Components/ViewResolver/ViewResolver';

import { ManageRequestList } from './desktop';
import { RequestListMobile } from './mobile';
import { ManageRequestListProps } from './desktop/ManageRequestList';
import { RequestListMobileProps } from './mobile/RequestListMobile';

interface RequestListProps
  extends ManageRequestListProps,
    RequestListMobileProps {}

const RequestList: React.FC<RequestListProps> = (props): JSX.Element | null => {
  const {
    onEdit,
    onView,
    onSubmit,
    onDelete,
    onCancel,
    onApprovalHistory,
    onLoadMore,
    requestsDataList,
    onCopy,
    listRequests,
    onChangePage,
    mapColumns,
    dataSource,
    onSort,
    requestType,
    currentPage,
    showAction,
    hidePagination = false,
    isFiltersApplied,
    isSearchApplied,
    ownActions,
  } = props;

  if (!listRequests) {
    return null;
  }

  return (
    <ViewResolver
      desktop={
        <ManageRequestList
          showAction={showAction}
          onEdit={onEdit}
          onView={onView}
          onSubmit={onSubmit}
          onDelete={onDelete}
          onCancel={onCancel}
          onCopy={onCopy}
          onApprovalHistory={onApprovalHistory}
          totalItems={listRequests.totalElements}
          pageSize={listRequests.size || listRequests.totalElements}
          onChangePage={onChangePage}
          currentPage={currentPage}
          mapColumns={mapColumns}
          dataSource={dataSource}
          onSort={onSort}
          hidePagination={hidePagination}
          isFiltersApplied={isFiltersApplied}
          isSearchApplied={isSearchApplied}
          requestType={requestType}
          ownActions={ownActions}
        />
      }
      mobile={
        <RequestListMobile
          listRequests={listRequests}
          requestsDataList={requestsDataList}
          requestType={requestType}
          showAction={showAction}
          ownActions={ownActions}
          onEdit={onEdit}
          onView={onView}
          onSubmit={onSubmit}
          onDelete={onDelete}
          onCancel={onCancel}
          onCopy={onCopy}
          onApprovalHistory={onApprovalHistory}
          onLoadMore={onLoadMore}
          isFiltersApplied={isFiltersApplied}
          isSearchApplied={isSearchApplied}
        />
      }
    />
  );
};

export default RequestList;
